import { computed, onMounted, reactive, ref } from "vue";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";

export function useFAQ() {
  const store = useStore();
  const { t } = useI18n();

  const categories = computed(() => store.state.faq.categories);
  const faqList = computed(() => store.state.faq.faqList);
  const activeCategory = ref<string | null>(null);
  const openItems = reactive<Record<string, boolean>>({});

  const loadData = async () => {
    try {
      await store.dispatch("faq/fetchFaqData");
      if (categories.value.length > 0) {
        activeCategory.value = categories.value[0].uuid;
      }
    } catch (error) {
      console.error(t("faq.loadError"), error);
    }
  };

  const toggleItem = (uuid: string) => {
    openItems[uuid] = !openItems[uuid];
  };

  const filteredFaq = computed(() => {
    if (!activeCategory.value) return [];
    return faqList.value.filter(
      (item) => item.category === activeCategory.value
    );
  });

  const slideClasses = (uuid: string) => {
    return [activeCategory.value === uuid ? "active" : ""];
  };

  onMounted(() => {
    loadData();
  });

  return {
    activeCategory,
    categories,
    filteredFaq,
    openItems,
    slideClasses,
    toggleItem,
  };
}
